export const constants = {
  RESET_ACTIVATION_INFO_STATE: "RESET_ACTIVATION_INFO_STATE",
  UPDATE_ACTIVATION_INFO: "UPDATE_ACTIVATION_INFO",
  RESET_LOCAL_STATE: "RESET_LOCAL_STATE",
  UPDATE_LOCAL: "UPDATE_LOCAL",
};
